import type { LineConfig } from "../hooks/useD3LineChart";

export type PerformanceChartVisualStyle = "default" | "retro";

// Space for the header, right-side values, and date axes.
export const RETRO_CHART_MARGINS = { top: 27, right: 58, bottom: 45, left: 14 };

export const RETRO_LINE_STYLES: Record<string, Pick<LineConfig, "stroke" | "strokeWidth" | "strokeDasharray">> = {
  performance: { stroke: "var(--retro-ink)", strokeWidth: 1.6 },
  performanceNet: { stroke: "var(--rp-amber)", strokeWidth: 1.2, strokeDasharray: "2 2" },
  bmk_SPX: { stroke: "var(--retro-secondary)", strokeWidth: 1.25, strokeDasharray: "4 3" },
  bmk_NDX: { stroke: "var(--retro-secondary)", strokeWidth: 1.25, strokeDasharray: "8 3 2 3" },
  bmk_IWM: { stroke: "var(--retro-secondary)", strokeWidth: 1.25, strokeDasharray: "1 3" },
};
